import React, { useEffect, useState } from "react";
import ScaleLoader from "react-spinners/ScaleLoader";

function Loader() {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 5000);
  }, []);

  return (
    <div className="loader">
      {loading ? (
        <ScaleLoader
          color={"#123abc"}
          loading={loading}
          size={350}
          aria-label="Loading Spinner"
          data-testid="loader"
        />
      ) : (
        <div>
          <p>Loading...</p>
        </div>
      )}
    </div>
  );
}

export default Loader;
